import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { Col, Row } from 'elements'
import { formSubmit } from 'utils/form'
import { listAllSites, listAllZones } from 'redux/modules/model/site'
import { listClients } from 'redux/modules/model/client'
import { createCamera } from 'redux/modules/model/camera'
import { listAllAgents } from 'redux/modules/model/agent';
import { clientsSelector, allSitesInfoSelector, agentsSelector, allZonesInfoSelector } from 'redux/selectors'
import { CameraForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'operator-invite'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class CameraAdd extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    createCamera: PropTypes.func.isRequired,
    listClients: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, listClients, listAllSites, listAllAgents, listAllZones } = this.props
    listClients({ clientId })
    listAllSites({ clientId })
    listAllAgents({ clientId })
    listAllZones({ clientId })
  }

  handleSubmit = (values) => {
    const { clientId, history, createCamera } = this.props
    return formSubmit(createCamera, { ...values })
      .then(() => history.push(ROUTES.CAMERA))
  };

  render() {
    const { clientList, sites, agents, allZonesList } = this.props
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.CAMERA}>&laquo; Back</Link></p>
          <PageContentTitle>Add a new camera</PageContentTitle>
          <CameraForm onSubmit={this.handleSubmit} clients={clientList} sites={sites}
            agents={agents} zones={allZonesList} />
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  clientList: clientsSelector,
  sites: allSitesInfoSelector,
  agents: agentsSelector,
  allZonesList: allZonesInfoSelector
})

export const actions = {
  createCamera,
  listClients,
  listAllSites,
  listAllAgents,
  listAllZones
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(CameraAdd)



// WEBPACK FOOTER //
// ./src/pages/camera/camera-add/index.js